import { type Maybe, type Unsubscribe } from '@amazon/vinyl-util'
import { applyBrightnessRgb, type Hsl, hslToRgb, type Rgb, rgbToCss } from '@/util/color'
import type { ImageModel } from '@/components/ImageView'
import { data, type MaybeObservableValue } from '@amazon/vinyl-observable'
import { triadicColorData } from '@/util/getTriadicColor'

export type BgColors = Maybe<readonly [Maybe<Hsl>, Maybe<Hsl>, Maybe<Hsl>]>

export const bgColors = data<BgColors>(null)

export function setBgColorsFromImage(imageModel: MaybeObservableValue<ImageModel>): Unsubscribe {
    return triadicColorData(imageModel).onData((v) => (bgColors.value = v))
}

export function setBgColors(colors: BgColors) {
    bgColors.value = colors
}

export function applyBgColors(target: HTMLElement, colors: BgColors) {
    if (!colors) colors = [null, null, null]
    const rgb: Rgb = { r: 0, g: 0, b: 0, a: 1 }
    for (let i = 0; i < colors.length; i++) {
        const prop = `--bg-g${i + 1}`
        const color = colors[i]
        if (color) {
            hslToRgb(color, rgb)
            if (color.l > 0.5) applyBrightnessRgb(rgb, Math.min(0.5, color.l))
            target.style.setProperty(prop, rgbToCss(rgb))
        } else {
            target.style.removeProperty(prop)
        }
    }
}
